module.exports = __webpack_public_path__ + "img/rate.c205a942.svg";